module.exports = __webpack_public_path__ + "static/frameLarge-b2529b83b87f11d4bfd5dad32ecc693a.png";